export default __webpack_public_path__ + "static/media/upload.fa23932e.png";